var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-title-bar',{attrs:{"engOne":'RISK',"engTwo":'CONTROL',"engTitle":'风险控制'}}),_c('div',{staticClass:"risk_box"},[_c('ul',_vm._l((_vm.riskCont),function(r,index){return _c('li',{key:index},[_vm._v(_vm._s(r))])}),0)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }